import { Breadcrumb, Layout } from "antd";
import { color } from "src/styles/globals";
import { down } from "styled-breakpoints";
import styled from "styled-components";

const { Content, Sider } = Layout;

export const Container = styled.div`
  background-color: ${color.charcoal01};
  min-height: 66.67vh; // follow min-height of withLayout CustomContent
  padding: 40px;
  ${down("md")} {
    padding: 0px;
    margin: 0px;
    height: fit-content;
    min-height: fit-content;
  }
`;

export const CustomLayout = styled(Layout)<{ hideSidebar?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: ${(props) => (props.hideSidebar ? "center" : "flex-start")};
  margin: 0 auto;
  padding-bottom: 80px;
  max-width: 1192px;
  background: none;
  column-gap: 32px;
  ${down("md")} {
    padding: 0px;
    height: fit-content;
  }
`;

export const CustomContent = styled(Content)<{ padding?: string }>`
  padding: ${(props) => props.padding || "24px"};
  max-width: 886px;
  width: 100%;
  height: fit-content;
  background-color: ${color.white};
  border: 1px solid ${color.charcoal03};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  ${down("md")} {
    padding: ${(props) => props.padding || "16px"};
    margin: 0px;
    border-radius: 0px;
    border: none;
    max-width: 100%;
    min-height: 600px;
  }
`;

export const CustomSider = styled(Sider)`
  background: white;
  border: 1px solid ${color.charcoal03};
  border-radius: 12px;
  overflow: hidden;
  height: fit-content;
  width: 100% !important;
  max-width: 275px !important;
  flex: auto !important;
`;

export const StyledBreadcrumb = styled(Breadcrumb)`
  margin: auto;
  padding-bottom: 40px;
  max-width: 886px;
  width: 100%;
  display: flex;
  span {
    display: flex;
  }
  span .ant-breadcrumb-link > div > a:hover {
    color: ${color.carrotOrange};
  }
  span:last-child {
    pointer-events: none;
  }
  span:last-child .ant-breadcrumb-link > div {
    font-weight: bold;
  }
  ${down("md")} {
    margin: 0px;
    padding: 16px 24px;
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: ${color.charcoal10};
  display: flex;
  width: fit-content;
  column-gap: 4px;
  div {
    font-weight: bold;
  }
`;

export const PrevButton = styled.div`
  width: 100%;
  margin: auto;
  padding: 16px 24px;
  max-width: 886px;
`;
